"use client";

import { createContext, useContext } from "react";

interface AdminShellContextValue {
  mobileSidebarOpen: boolean;
  setMobileSidebarOpen: (open: boolean) => void;
}

const AdminShellContext = createContext<AdminShellContextValue | null>(null);

export function AdminShellProvider({
  value,
  children,
}: {
  value: AdminShellContextValue;
  children: React.ReactNode;
}) {
  return (
    <AdminShellContext.Provider value={value}>
      {children}
    </AdminShellContext.Provider>
  );
}

export function useAdminShell() {
  return useContext(AdminShellContext);
}
